var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-empresa"},[_c('carrossel-imagens',{attrs:{"imagens":_vm.imagensBanner,"altura":"200px","altura-desktop":"280px","autoplay":5000,"clicavel":"","setas":""},on:{"selecionar":function($event){return _vm.selDestaque($event.link)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }